import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { NgClass, NgIf } from '@angular/common';

@Component({
    selector: 'lib-alert-error',
    standalone: true,
    imports: [NgIf, NgClass],
    templateUrl: './alert-error.component.html',
    styleUrl: './alert-error.component.scss'
})
export class AlertErrorComponent {
    @Input() alertField!: AbstractControl | null;

    @Input() minValue: number | null | undefined;

    @Input() maxValue: number | null | undefined;

    @Input() marginClass? = false;

    public isDefinedNumber(val: number | null | undefined): boolean {
        return val !== null && val !== undefined && val > 0;
    }
}
